import Dexie from "dexie";
class AppDb extends Dexie {
  public config: Dexie.Table<IConfig, number>;
  public chapter: Dexie.Table<IChapter, number>;
  public section: Dexie.Table<ISection, number>;
  public question: Dexie.Table<IQuestion, number>;
  public choice: Dexie.Table<IChoice, number>;
  public flashcard: Dexie.Table<IFlashcard, number>;
  public questionResult: Dexie.Table<IQuestionResult, number>;
  public flashcardResult: Dexie.Table<IFlashcardResult, number>;
  public dayData: Dexie.Table<IDayData, number>;
  public searchQuery: Dexie.Table<SearchQuery, number>;
  public flashSearchQuery: Dexie.Table<FlashSearchQuery, number>;
  public result: Dexie.Table<IResult, number>;

  constructor() {
    super("AppDatabase");
    try {
      this.createStore()
    } catch {
      this.delete().then(_ => {
        this.createStore()
      })
    }

    

    this.config = this.table("config");
    this.chapter = this.table("chapter");
    this.section = this.table("section");
    this.question = this.table("question");
    this.choice = this.table("choice");
    this.flashcard = this.table("flashcard");
    this.questionResult = this.table("questionResult");
    this.flashcardResult = this.table("flashcardResult");
    this.flashSearchQuery = this.table("flashSearchQuery");
    this.dayData = this.table("dayData");
    this.searchQuery = this.table("searchQuery");
    this.result = this.table("result");
  }

  private createStore() {
    this.version(1).stores({
      config: "++id,goalCount,version",
      chapter: "++id,no,name",
      section: "++id,chapterId,no,name",
      question: "++id,chapterId,sectionId,no,lessonNo,lessonTitle,text,lecture",
      choice: "++id,questionId,no,answer,text,lecture",
      flashcard: "++id,chapterId,sectionId,title,text",
      questionResult: "++id,chapterId,sectionId,questionId,allCount,correctCount,isBookmark,history,reviewHistory,historyTime",
      flashcardResult: "++id,flashcardId,allCount,lastResult",
      dayData: "++id,dateStr,count",
      searchQuery: "++id,chapterId,sectionId",
      flashSearchQuery: "++id,chapterId,sectionId,type",
      result: "++id,questionId,isAnswer,isCorrect,choice",
    });
  }
}

interface IConfig {
  id?: number;
  goalCount: number,
  time: number
  version: number;
}

interface IChapter {
  id?: number;
  no: number;
  name: string;
}

interface ISection {
  id?: number;
  chapterId: number
  no: number;
  name: string;
}

interface IQuestion {
  id?: number;
  chapterId: number;
  sectionId: number
  no: number
  lessonNo: number
  lessonTitle: string
  examNo: string;
  text: string;
  lecture: string;
}

interface IChoice {
  id?: number;
    questionId: number;
    no: number;
    answer: number;
    text: string;
    lecture: string;
}

interface IFlashcard {
  id?: number;
  chapterId: number;
  sectionId: number
  title: string
  text: string;
}

interface IQuestionResult {
  id?: number;
  chapterId: number;
  sectionId: number
  questionId: number
  allCount: number;
  correctCount: number;
  isBookmark: boolean;
  history: string
  reviewHistory: string
  historyTime: string
}

interface IFlashcardResult {
  id?: number;
  flashcardId: number
  allCount: number;
  lastResult: number;
}

interface IDayData {
  id?: number;
  dateStr: string
  count: number;
}

interface IResult {
  id?: number;
  questionId: number
  isAnswer: boolean
  isCorrect: boolean
  choice: number,
}

interface QuestionSet {
  question: IQuestion
  chapter: IChapter
  section: ISection
  choices: IChoice[]
  questionResult: IQuestionResult,
  result: IResult
}

interface BookSet {
  chapter: IChapter
  sections: BookData[]
}

interface BookData {
  section: ISection
  img: string
}

interface SearchQuery
{
  id?: number;
  chapterId: number
  sectionId: number
  bookmark: boolean
}

interface FlashSearchQuery
{
  id?: number;
  chapterId: number
  sectionId: number
  type: number
}

export { AppDb, IChapter, IConfig, IQuestion, IChoice, IFlashcard, ISection, IQuestionResult, IFlashcardResult, IDayData, QuestionSet, FlashSearchQuery, BookSet, BookData, SearchQuery, IResult };